"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEMS = void 0;
exports.asTypedItemPrototype = asTypedItemPrototype;
exports.asTypedItemInstance = asTypedItemInstance;
const Amount_1 = __importDefault(require("./Amount"));
const Checkbox_1 = __importDefault(require("./Checkbox"));
const Checklist_1 = __importDefault(require("./Checklist"));
const Custom_1 = __importDefault(require("./Custom"));
const CustomV2_1 = __importDefault(require("./CustomV2"));
const Date_1 = __importDefault(require("./Date"));
const DateTime_1 = __importDefault(require("./DateTime"));
const Email_1 = __importDefault(require("./Email"));
const FileUploadV2_1 = __importDefault(require("./FileUploadV2"));
const Location_1 = __importDefault(require("./Location"));
const MultiLineText_1 = __importDefault(require("./MultiLineText"));
const MultiSelect_1 = __importDefault(require("./MultiSelect"));
const Rating_1 = __importDefault(require("./Rating"));
const Schedule_1 = __importDefault(require("./Schedule"));
const Signature_1 = __importDefault(require("./Signature"));
const SingleSelect_1 = __importDefault(require("./SingleSelect"));
const SlackMessage_1 = __importDefault(require("./SlackMessage"));
const Subquest_1 = __importDefault(require("./Subquest"));
const Switch_1 = __importDefault(require("./Switch"));
const Text_1 = __importDefault(require("./Text"));
const UserPicker_1 = __importDefault(require("./UserPicker"));
const Video_1 = __importDefault(require("./Video"));
/**
 * Item Definitions for each ItemType.
 *
 * Definitions assist with typing of config and data Json Objects as well as validations.
 */
exports.ITEMS = {
    Amount: Amount_1.default,
    Checkbox: Checkbox_1.default,
    Checklist: Checklist_1.default,
    Custom: Custom_1.default,
    CustomV2: CustomV2_1.default,
    Date: Date_1.default,
    DateTime: DateTime_1.default,
    Email: Email_1.default,
    FileUploadV2: FileUploadV2_1.default,
    Location: Location_1.default,
    MultiLineText: MultiLineText_1.default,
    MultiSelect: MultiSelect_1.default,
    Rating: Rating_1.default,
    Schedule: Schedule_1.default,
    Signature: Signature_1.default,
    SingleSelect: SingleSelect_1.default,
    SlackMessage: SlackMessage_1.default,
    Subquest: Subquest_1.default,
    Switch: Switch_1.default,
    Text: Text_1.default,
    UserPicker: UserPicker_1.default,
    Video: Video_1.default,
};
function asTypedItemPrototype(item) {
    return item;
}
function asTypedItemInstance(item) {
    return item;
}
//# sourceMappingURL=index.js.map